import { render, staticRenderFns } from "./classroom.vue?vue&type=template&id=db16152c&scoped=true&"
import script from "./classroom.vue?vue&type=script&lang=js&"
export * from "./classroom.vue?vue&type=script&lang=js&"
import style0 from "./classroom.vue?vue&type=style&index=0&id=db16152c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db16152c",
  null
  
)

export default component.exports